import React from 'react';
import {
  Alert,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
} from 'reactstrap';
import { isURL } from 'validator';
import { Link, withRouter } from 'react-router-dom';
import Card from '../../../../components/Card/Card';
import DomainUrl from '../../../../components/Domains/DomainUrl';
import DomainDisclaimer from '../../../../components/Domains/DomainDisclaimer';
import DomainTypes from '../../../../components/Domains/DomainTypes';
import FlowOffers from '../../../../components/Flow/FlowOffers';
import FlowTDS from '../../../../components/Flow/FlowTDS';
import FlowLandingsTable from '../../../../components/Flow/FlowLandingsTable';
import AlertModal from '../../../../modals/AlertModal/AlertModal';
import { FMessage, FHTMLMessage } from '../../../../hoc/IntlComponents';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../../components/Icon/Icon';
import DomainReplicaWarning from '../../../../components/Domains/DomainReplicaWarning';

export default class DomainForm extends React.Component {
  render() {
    const {
      stateData,
      propsData,
      handleSubmit,
      handleDomainCheck,
      handleDomainChange,
      getTypes,
      handleTypeChange,
      getOffersWithNoReplics,
      handleOfferChange,
      handleChange,
      handleTDSChange,
      getParkingType,
      handleLandingsChange,
      handlePrelandersChange,
      toggleModal,
      replicaOffersIds,
    } = this.props;

    const { modal, errors, message } = stateData;
    const { type, domain, offerId, landings, prelanders, tdsId, title } = stateData.domain;
    const { isEdit, loading, offer, tdsStreams, profile } = propsData;
    const { site_key } = profile;

    this.getFaqLink = type => {
      switch (type) {
        case 'tracking':
          return '/faq/tools/parking/types/click-multi-type';
        case 'landing':
          return '/faq/tools/parking/types/landing-type';
        case 'prelander':
          return '/faq/tools/parking/types/trans-type';
        case 'tds':
          return '/faq/tools/parking/types/tds-type';
        default:
          return '/faq/tools/parking/types/click-type';
      }
    };

    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col lg="6">
            <h6>
              <FMessage id="domains.form.instruction.title" />
            </h6>
            <p className="mb-3">
              <FMessage id="domains.form.instruction.subtitle" />
            </p>
            <div>
              <FormattedMessage
                id="domains.tutorial.step.1"
                defaultMessage="1. But a domain and setup the following NS records in registrator panel:"
              />
              <br />
              <span id="domain-tutorial--ns1" className="domains-tutorial--link">
                ns1.mrrffo.com&nbsp;
              </span>
              <br />
              <span id="domain-tutorial--ns2" className="domains-tutorial--link">
                ns2.mrrffo.com&nbsp;
              </span>
              <p className="domains-tutorial--small">
                <FormattedMessage
                  id="domains.tutorial.step.1.disclaimer"
                  defaultMessage="Wait for the changes to take effect. This process can last up to 72 hours, usually 60 minutes."
                />
              </p>
            </div>

            <p>
              <FormattedMessage
                values={{ stepID: 2 }}
                id="domains.tutorial.step.2"
                defaultMessage="2. Choose parking domain type;"
              />
            </p>
            <DomainTypes
              type={type}
              types={getTypes().filter(({ id }) => id !== 'click')}
              onTypeChange={handleTypeChange}
              disabled={isEdit}
              theme={4}
            />
            <p>
              <FormattedMessage
                values={{ stepID: 3 }}
                id="domains.tutorial.step.3"
                defaultMessage="3. Past your domain's URL and press the Add domain button;"
              />
            </p>
            <DomainUrl
              theme={4}
              message={message}
              url={domain}
              isEdit={isEdit}
              onCheckDomain={handleDomainCheck}
              onUrlChange={handleDomainChange}
            />

            {(type === 'landing' || type === 'prelander') && (
              <FlowOffers
                inDomainsForm
                theme={4}
                offers={getOffersWithNoReplics()}
                offerId={offerId}
                onOfferChange={handleOfferChange}
                error={errors.offer}
                disabled={isEdit}
              />
            )}

            {type === 'tds' && (
              <>
                <FormGroup className={errors.title ? 'has-error' : ''}>
                  <Label htmlFor="title">
                    <FormattedMessage id="flow.form.title" defaultMessage="Title" />
                  </Label>
                  <Input
                    id="title"
                    type="text"
                    name="title"
                    value={title}
                    onChange={handleChange}
                  />
                  {errors.title && <small className="form-text">{errors.title}</small>}
                </FormGroup>

                <FlowTDS
                  theme={4}
                  tdsStreams={tdsStreams}
                  tdsId={tdsId}
                  onTDSChange={handleTDSChange}
                  error={errors.tds}
                  disabled={isEdit}
                />
              </>
            )}
            {replicaOffersIds?.length > 0 ? <DomainReplicaWarning /> : null}
          </Col>

          <Col>
            <Alert>
              <Icon type="warning" className="text-danger" />
              <span className="font-weight-bolder text-danger">
                {' '}
                <FormattedMessage id="main.attension" defaultMessage="Attention" />
              </span>{' '}
              <FormattedMessage
                id="domains.tutorial.disclaimer"
                defaultMessage="Register NS records for one example.com domain only once, and all the top.example.com subdomains can simply be added to our system without any changes on the registrar's side."
              />
              <a className="domains-tutorial--faq-link" href={`/faq/tools/parking`} target="_blank">
                <FormattedMessage id="domains.tutorial.faq_link" defaultMessage="" />
              </a>
            </Alert>
          </Col>

          {offer && (
            <Col xs="12">
              {errors.landings && <Alert color="danger">{errors.landings}</Alert>}
              {errors.prelanders && <Alert color="danger">{errors.prelanders}</Alert>}

              {type === 'landing' && offer.landings && (
                <Card>
                  <Card.Header>
                    <FormattedMessage id="flow.landings" defaultMessage="Landings" />
                  </Card.Header>
                  <Card.Body className="no-padding">
                    {offer.landings.length > 0 ? (
                      <FlowLandingsTable
                        name="landings"
                        landings={offer.landings}
                        checked={landings}
                        onLandingChange={handleLandingsChange}
                        showStreamCr={false}
                        multiple={false}
                        offerId={offer.id}
                        offer={offer}
                        site_key={site_key}
                        inDomain
                      />
                    ) : (
                      <div className="card-empty">
                        <FormattedMessage id="flow.no-landings" defaultMessage="No Landings" />
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}

              {type === 'prelander' && offer.transits && (
                <Card>
                  <Card.Header>
                    <FormattedMessage id="flow.prelanders" defaultMessage="Prelanders" />
                  </Card.Header>
                  <Card.Body className="no-padding">
                    {offer.transits.length > 0 ? (
                      <FlowLandingsTable
                        name="prelanders"
                        landings={offer.transits}
                        checked={prelanders}
                        onLandingChange={handlePrelandersChange}
                        showStreamCr={false}
                        multiple={false}
                        offerId={offer.id}
                        offer={offer}
                        site_key={site_key}
                        inDomain
                      />
                    ) : (
                      <div className="card-empty">
                        <FormattedMessage id="flow.no-prelanders" defaultMessage="No Prelanders" />
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <FormGroup>
              {isEdit ? (
                type === 'tracking' ? null : (
                  <Button color="primary" size="lg" disabled={!isURL(domain)}>
                    <FormattedMessage id="domain.form.save" defaultMessage="Save Domain" />
                  </Button>
                )
              ) : (
                <Button color="primary" disabled={!isURL(domain)}>
                  <FormattedMessage id="domain.form.add" defaultMessage="Add Domain" />
                </Button>
              )}
            </FormGroup>
          </Col>
        </Row>

        {/* <AlertModal open={modal} message={message} onClose={toggleModal} /> */}
      </form>
    );
  }
}
